import styled, { css } from "styled-components";

import Props from "./props";

const Flex = styled.div<Props>`
    flex: ${({ grow }) => grow};
    ${({ right }) =>
        right &&
        css`
            text-align: right;
        `}
`;

export default Flex;
